define("calendar/components/calendar/onboarding/wizards/schedule-first-post", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "later/utils/constants", "later/utils/time-format", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _constants, _timeFormat, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _openEmptyPostBuilder;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"later/utils/constants",0,"later/utils/time-format",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Wizard @closable={{false}} as |wizard|>
    <wizard.slide @primaryClass="tOB--modalCard o--modalCard" as |slide|>
      <div class="tOB--wizard">
        <div class="tOB--wizard__left">
          <figure class="o--mediaContainer">
            <img class="o--media" src="/assets/images/img--ob__schedulePost.png" />
            <b class="o--mediaOverlay"></b>
          </figure>
        </div>
        <div class="tOB--wizard__right">
          <div class="tOB--wizard__contentWrapper">
            <h2 class="tOB--wizard__title">
              {{t "onboarding.schedule_first_post.title"}}
            </h2>
            <ul class="tOB--wizard__ul--sm">
              <li class="tOB--wizard__li">
                {{t (concat "onboarding.schedule_first_post." this.scheduleFirstListStepOne)}}
              </li>
              <li class="tOB--wizard__li">
                {{t (concat "onboarding.schedule_first_post." this.scheduleFirstListStepTwo)}}
              </li>
              <li class="tOB--wizard__li">{{t "onboarding.schedule_first_post.tutorial_step_3"}}</li>
            </ul>
          </div>
  
          <footer class="tOB--wizard__footer--inner">
            <slide.finishButton
              @buttonClass="o--btn o--btn--block o--btn--primary"
              @finishWizard={{this.closeScheduleFirstPostWizard}}
              @onClick={{action @trackOnboardingStep "started-post-onboarding"}}
              @text={{t "onboarding.schedule_first_post.now"}}
              data-test-schedule-first-post-button="schedule-first-post-button"
            />
            <slide.finishButton
              @buttonClass="o--btn o--btn--block o--btn--outline u--m__t__xs"
              @finishWizard={{@transition}}
              @onClick={{action @trackOnboardingStep "skipped-post-onboarding"}}
              @text={{t "shared_phrases.not_now"}}
              data-test-schedule-first-post-button="not-now-button"
            />
          </footer>
        </div>
      </div>
    </wizard.slide>
  </Shared::Wizard>
  */
  {
    "id": "8Xy1PU61",
    "block": "[[[8,[39,0],null,[[\"@closable\"],[false]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"slide\"]],null,[[\"@primaryClass\"],[\"tOB--modalCard o--modalCard\"]],[[\"default\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"tOB--wizard\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tOB--wizard__left\"],[12],[1,\"\\n        \"],[10,\"figure\"],[14,0,\"o--mediaContainer\"],[12],[1,\"\\n          \"],[10,\"img\"],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--ob__schedulePost.png\"],[12],[13],[1,\"\\n          \"],[10,\"b\"],[14,0,\"o--mediaOverlay\"],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tOB--wizard__right\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"tOB--wizard__contentWrapper\"],[12],[1,\"\\n          \"],[10,\"h2\"],[14,0,\"tOB--wizard__title\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"onboarding.schedule_first_post.title\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"ul\"],[14,0,\"tOB--wizard__ul--sm\"],[12],[1,\"\\n            \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[[28,[37,2],[\"onboarding.schedule_first_post.\",[30,0,[\"scheduleFirstListStepOne\"]]],null]],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[[28,[37,2],[\"onboarding.schedule_first_post.\",[30,0,[\"scheduleFirstListStepTwo\"]]],null]],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,[28,[35,1],[\"onboarding.schedule_first_post.tutorial_step_3\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[10,\"footer\"],[14,0,\"tOB--wizard__footer--inner\"],[12],[1,\"\\n          \"],[8,[30,2,[\"finishButton\"]],[[24,\"data-test-schedule-first-post-button\",\"schedule-first-post-button\"]],[[\"@buttonClass\",\"@finishWizard\",\"@onClick\",\"@text\"],[\"o--btn o--btn--block o--btn--primary\",[30,0,[\"closeScheduleFirstPostWizard\"]],[28,[37,3],[[30,0],[30,3],\"started-post-onboarding\"],null],[28,[37,1],[\"onboarding.schedule_first_post.now\"],null]]],null],[1,\"\\n          \"],[8,[30,2,[\"finishButton\"]],[[24,\"data-test-schedule-first-post-button\",\"not-now-button\"]],[[\"@buttonClass\",\"@finishWizard\",\"@onClick\",\"@text\"],[\"o--btn o--btn--block o--btn--outline u--m__t__xs\",[30,4],[28,[37,3],[[30,0],[30,3],\"skipped-post-onboarding\"],null],[28,[37,1],[\"shared_phrases.not_now\"],null]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[2]]]]],[1,\"\\n\"]],[1]]]]]],[\"wizard\",\"slide\",\"@trackOnboardingStep\",\"@transition\"],false,[\"shared/wizard\",\"t\",\"concat\",\"action\"]]",
    "moduleName": "calendar/components/calendar/onboarding/wizards/schedule-first-post.hbs",
    "isStrictMode": false
  });
  var TutorialStepOne = /*#__PURE__*/function (TutorialStepOne) {
    TutorialStepOne["TikTok"] = "tutorial_step_1_tiktok";
    TutorialStepOne["Twitter"] = "tutorial_step_1_twitter";
    TutorialStepOne["Default"] = "tutorial_step_1";
    return TutorialStepOne;
  }(TutorialStepOne || {});
  var TutorialStepTwo = /*#__PURE__*/function (TutorialStepTwo) {
    TutorialStepTwo["Pinterest"] = "tutorial_step_2_pinterest";
    TutorialStepTwo["Default"] = "tutorial_step_2";
    return TutorialStepTwo;
  }(TutorialStepTwo || {});
  let ScheduleFirstPostComponent = _exports.default = (_class = (_openEmptyPostBuilder = /*#__PURE__*/new WeakSet(), class ScheduleFirstPostComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _openEmptyPostBuilder);
      _initializerDefineProperty(this, "router", _descriptor, this);
      _initializerDefineProperty(this, "segment", _descriptor2, this);
    }
    get isTiktok() {
      return this.args.socialProfile?.isTiktok ?? false;
    }
    get isTwitter() {
      return this.args.socialProfile?.isTwitter ?? false;
    }
    get isPinterest() {
      return this.args.socialProfile?.isPinterest ?? false;
    }
    get scheduleFirstListStepOne() {
      const stepOneTiktok = this.isTiktok && TutorialStepOne.TikTok;
      const stepOneTwitter = this.isTwitter && TutorialStepOne.Twitter;
      return stepOneTiktok || stepOneTwitter || TutorialStepOne.Default;
    }
    get scheduleFirstListStepTwo() {
      const stepTwoPinterest = this.isPinterest && TutorialStepTwo.Pinterest;
      return stepTwoPinterest || TutorialStepTwo.Default;
    }
    closeScheduleFirstPostWizard() {
      _classPrivateMethodGet(this, _openEmptyPostBuilder, _openEmptyPostBuilder2).call(this);
      this.args.transition();
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "closeScheduleFirstPostWizard", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeScheduleFirstPostWizard"), _class.prototype)), _class);
  function _openEmptyPostBuilder2() {
    this.router.transitionTo('cluster.schedule.calendar.post.new', _constants.TEXT_POST_TYPE, {
      queryParams: {
        scheduledTime: (0, _timeFormat.timestamp)()
      }
    });
    this.segment.track('started-scheduling-post', {
      area: 'schedule_post_onboarding_modal'
    });
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ScheduleFirstPostComponent);
});